import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  submitButton: {
    backgroundColor: "#1565C0",
    color: "#ffffff",
    textTransform: "none",
    fontSize: "1rem",
    fontWeight: 500,
    padding: "12px",
    "&:hover": {
      backgroundColor: "#0d47a1",
    },
  },
  backButton: {
    color: "#1565C0",
    textTransform: "none",
    padding: 0,
    fontSize: "1rem",
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "underline",
    },
  },
}));

const MFAForm = ({
  onSubmit,
  classes,
  errorMessage,
  open,
  setErrorMessage,
  handleChangeLocation,
}) => {
  const formClasses = useStyles();

  return (
  <Formik
    initialValues={{ code: "" }}
    validationSchema={Yup.object().shape({
      code: Yup.string()
        .matches(/^\d+$/, "Code must contain only numbers")
        .min(6, "Code must be at least 6 digits")
        .max(8, "Code must be at most 8 digits")
        .required("Verification code is required"),
    })}
    onSubmit={onSubmit}
  >
    {({
      errors,
      handleBlur,
      handleChange,
      handleSubmit,
      touched,
      values,
      isValid,
      dirty,
    }) => (
      <form noValidate onSubmit={handleSubmit} className={classes.formStyle}>
        <Box mb={2}>
          <Typography variant="body2" style={{ marginBottom: "8px", color: "#424242", fontSize: "0.875rem" }}>
            Verification Code
          </Typography>
          <TextField
            error={Boolean(touched.code && errors.code)}
            fullWidth
            helperText={touched.code && errors.code}
            placeholder="Enter 6-digit code"
            name="code"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.code}
            variant="outlined"
            inputProps={{
              maxLength: 8,
              pattern: "[0-9]*",
              inputMode: "numeric"
            }}
          />
        </Box>
        <Box mt={3}>
          <Button
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            className={formClasses.submitButton}
            disabled={!isValid || !dirty}
          >
            Verify Code
          </Button>
        </Box>
        <Box mt={2} textAlign="center">
          <Button
            onClick={() => handleChangeLocation("login")}
            className={formClasses.backButton}
          >
            Back to Login
          </Button>
        </Box>
      </form>
    )}
  </Formik>
  );
};

export default MFAForm;